import { ButtonLink, PlainButtonLink } from "@/components/marketing/elements/button"
import { CallToActionSimple } from "@/components/marketing/sections/call-to-action-simple"
import { CallToActionSimpleCentered } from "@/components/marketing/sections/call-to-action-simple-centered"
import { primaryCtaHref, primaryCtaLabel } from "@/lib/launch-config"

export function MarketingCta({ centered = false }: { centered?: boolean }) {
  const content = {
    headline: "Ready to write your first scenarios?",
    subheadline: (
      <p>
        Create a workspace, start a project, and write your first scenarios right in the app — you&apos;ll be
        browsing them in minutes.
      </p>
    ),
    cta: (
      <div className="flex flex-wrap items-center justify-center gap-4">
        <ButtonLink href={primaryCtaHref()} size="lg">
          {primaryCtaLabel()}
        </ButtonLink>
        <PlainButtonLink href="/#pricing" size="lg">
          See pricing
        </PlainButtonLink>
      </div>
    ),
  }

  if (centered) {
    return (
      <CallToActionSimpleCentered id="call-to-action" headline={content.headline} subheadline={content.subheadline} cta={content.cta} />
    )
  }

  return (
    <CallToActionSimple id="call-to-action" headline={content.headline} subheadline={content.subheadline} cta={content.cta} />
  )
}
